export default defineNuxtPlugin(() => {
  const route = useRoute();

  const config = {
    icon: (targetPage: string): string =>
      route.name !== targetPage
        ? 'text-gray-800 hover:text-blue-500'
        : 'text-white',

    button: (isActive: boolean): string =>
      isActive ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700',

    link: (href: string): string =>
      route.path === href ? 'underline text-blue-500' : 'text-gray-600 hover:text-blue-400',
  };

  return {
    provide: {
      colors: config,
    },
  };
});